import React from "react";
import "./css/style.scss";

import DynamicTab from "../../../components/dynamicTab";
import WidgetTile from "../../../components/widgetTile";
import {
  FaGlobeAmericas,   // for North America/Global expansion
  FaHandshake,       // for partnerships/distributors
  FaCapsules,        // for OTC/prescription sales
} from "react-icons/fa";

// Actions data with icons
const actions = [
  {
    id: "1",
    content:
      "Enhance cost control in Asia by continuing to reduce loan disbursement costs while managing operating margins carefully to sustain profitability.",
    rating: "4.5",
    icon: FaCapsules,
  },
  {
    id: "2",
    content:
      "Focus on managing rising operating expenses in the Americas by optimizing operational efficiency and deploying targeted risk management strategies.",
    rating: "4.3",
    icon: FaGlobeAmericas,
  },

];

// Sections for DynamicTab
const sections = [
  {
    id: "1",
    key: "actions",
    display_name: "Actions",
    apiEndpoint: "",
    tab_content: (
      <div>
        {actions.map((action, index) => (
          <div
            key={action.id}
            style={{
              padding: "8px 0",
              borderBottom:
                index + 1 !== actions.length
                  ? "0.22px solid var(--primary-border-bottom-color)"
                  : "none",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {/* Icon + Content */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "12px",
                  alignItems: "center",
                }}
              >
                {action.icon && (
                  <action.icon
                    style={{
                      fontSize: "1.2rem",
                      color: "var(--primary-icon-color)",
                      minWidth: "20px",
                    }}
                  />
                )}
                <span
                  style={{
                    color: "var(--card-secondary-color)",
                    textAlign: "left",
                    fontSize: "14px",
                    lineHeight: "1.4",
                  }}
                >
                  {action.content}
                </span>
              </div>

              {/* Right Arrow */}
              <button
                style={{
                  background: "none",
                  border: "none",
                  padding: "0px",
                  minWidth: "24px",
                  color: "var(--primary-icon-color)",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
                title="View"
              >
                ➔
              </button>
            </div>
          </div>
        ))}
      </div>
    ),
  },
  {
    id: "2",
    key: "boards",
    display_name: "Boards",
    apiEndpoint: "",
    disabled: true,
    tab_content: <div />,
  },
  {
    id: "3",
    key: "prompts",
    display_name: "Prompts",
    apiEndpoint: "",
    disabled: true,
    tab_content: <div />,
  },
];

const WidgetRecommendedActions = () => {
  return (
    <WidgetTile
      title={"Recommendations"}

      bodyContent={
        <DynamicTab
          sections={sections}
          skeletonRows={3}
          sx={{
            tabHeaderColor: (active, disabled) => ({
              color: disabled
                ? "var(--card-tertiary-color) !important"
                : active
                ? "var(--active-option-color) !important"
                : "var(--card-secondary-color) !important",
              cursor: disabled ? "not-allowed" : "pointer",
            }),
            tabHeaderWeight: (active) => ({
              fontWeight: active ? "600" : "500",
            }),
            tabContent: {
              padding: "15px 0 0 0",
            },
            indicator: {
              backgroundColor: "var(--active-option-color)",
              height: "3px",
              borderRadius: "30px",
            },
            indicatorBottom: {
              borderBottom: "1px solid var(--primary-border-bottom-color)",
            },
          }}
          skeletonLoader={{
            rowCount: 3,
            rowHeight: "35px",
            sx: { gap: "32px" },
          }}
        />
      }
    />
  );
};

export default WidgetRecommendedActions;
 